import _jsx from "@babel/runtime/helpers/jsx";
var _Glyphicon;
import React from 'react';
import clsx from 'clsx';
import { Glyphicon, Label } from 'reaxl';

/**
 *  Renders a certified badge for use in InventoryListingBadges
 */
function CertifiedBadge(_ref) {
  let {
    label,
    listingType,
    listingTypes,
    onClick
  } = _ref;
  if (!label) return null;
  let showIcon = false;
  const isCertified = listingType.toLowerCase() === 'certified';
  const hasCert = !!listingTypes.find(option => option.code === 'CERTIFIED');
  const has3PCert = !!listingTypes.find(option => option.code === '3P_CERT');
  if (isCertified && hasCert && !has3PCert) {
    showIcon = true;
  }
  return /*#__PURE__*/_jsx(Label, {
    bsStyle: "default",
    className: clsx({
      'display-inline-flex gap-1': showIcon
    }, 'link-undecorated'),
    "data-cmp": "certifiedBadge",
    onClick: onClick,
    role: "button",
    tabIndex: 0
  }, void 0, showIcon && (_Glyphicon || (_Glyphicon = /*#__PURE__*/_jsx(Glyphicon, {
    glyph: "certified"
  }))), label);
}
export default CertifiedBadge;